'use client';

import { useEffect } from 'react';
import { Locale } from '@headless-workspace/config';
import { DataLayerKey, HeaderDidMount, useDataLayer } from '@headless-workspace/domain/common/client';
import { Component } from '@headless-workspace/typings';
import { DATA_PRODUCT_ID, DATA_PRODUCT_SKU, PRODUCT_DETAIL_TEMPLATE_ID } from '../../../../server';

const DATA_LAYER_CONNECTION_ACTION = '';

type ProductDetailDidMountProps = {
    locale: Locale;
};

export const ProductDetailDidMount: Component<ProductDetailDidMountProps> = ({ locale }) => {
    const { trackEvent, addVariable, addVariables, trackT2SEvent, deleteVariable } = useDataLayer({
        [DataLayerKey.ProductDisplayType]: 'product page',
    });

    useEffect(() => {
        if (typeof document !== 'undefined') {
            const productElement = document.getElementById(PRODUCT_DETAIL_TEMPLATE_ID);

            const productId = productElement?.getAttribute(DATA_PRODUCT_ID) ?? '';
            addVariable(DataLayerKey.ProductPid, productId);

            const productSku = productElement?.getAttribute(DATA_PRODUCT_SKU) ?? '';
            addVariable(DataLayerKey.ProductSku, productSku);
        }
    }, [addVariable]);

    return (
        <HeaderDidMount
            dataLayerConnectionAction={DATA_LAYER_CONNECTION_ACTION}
            trackEvent={trackEvent}
            locale={locale}
            addVariables={addVariables}
            trackT2SEvent={trackT2SEvent}
            deleteVariable={deleteVariable}
        />
    );
};
